"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountApiKeyGenerateRequestToJSON = exports.AccountApiKeyGenerateRequestFromJSONTyped = exports.AccountApiKeyGenerateRequestFromJSON = exports.instanceOfAccountApiKeyGenerateRequest = exports.attributeTypeMapAccountApiKeyGenerateRequest = void 0;
exports.attributeTypeMapAccountApiKeyGenerateRequest = [
    {
        name: "name",
        type: "string",
    },
];
/**
 * Check if a given object implements the AccountApiKeyGenerateRequest interface.
 */
function instanceOfAccountApiKeyGenerateRequest(value) {
    if (!("name" in value) || value["name"] === undefined)
        return false;
    return true;
}
exports.instanceOfAccountApiKeyGenerateRequest = instanceOfAccountApiKeyGenerateRequest;
function AccountApiKeyGenerateRequestFromJSON(json) {
    return AccountApiKeyGenerateRequestFromJSONTyped(json, false);
}
exports.AccountApiKeyGenerateRequestFromJSON = AccountApiKeyGenerateRequestFromJSON;
function AccountApiKeyGenerateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        name: json["name"],
    };
}
exports.AccountApiKeyGenerateRequestFromJSONTyped = AccountApiKeyGenerateRequestFromJSONTyped;
function AccountApiKeyGenerateRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        name: value["name"],
    };
}
exports.AccountApiKeyGenerateRequestToJSON = AccountApiKeyGenerateRequestToJSON;
